import React, { useMemo } from "react";

import {

    Row,
    Col,
    Card,
    Statistic

} from "antd";

import {

    MessageOutlined,
    BellOutlined,
    DollarCircleOutlined,
    CheckCircleOutlined,
    InboxOutlined,
    ClockCircleOutlined

} from "@ant-design/icons";

const NotificationStats = ({

                               conversations = []

                           }) => {

    const stats = useMemo(() => {

        const unread = conversations.filter(

            c => c.hasUnreadMessage

        ).length;

        const negotiation = conversations.filter(

            c =>

                c.status === "NEGOTIATION"

        ).length;

        const agreement = conversations.filter(

            c =>

                c.status === "AGREEMENT_PENDING"

        ).length;

        const payment = conversations.filter(

            c =>

                c.status === "PAYMENT_PENDING"

        ).length;

        const archived = conversations.filter(

            c => c.archived

        ).length;

        return {

            total: conversations.length,

            unread,

            negotiation,

            agreement,

            payment,

            archived

        };

    }, [conversations]);

    return (

        <Row gutter={[16,16]}>

            <Col xs={12} md={8} lg={4}>

                <Card>

                    <Statistic

                        title="Notifications"

                        value={stats.total}

                        prefix={<BellOutlined />}

                    />

                </Card>

            </Col>

            <Col xs={12} md={8} lg={4}>

                <Card>

                    <Statistic

                        title="Non lues"

                        value={stats.unread}

                        valueStyle={{

                            color:"#cf1322"

                        }}

                        prefix={<MessageOutlined />}

                    />

                </Card>

            </Col>

            <Col xs={12} md={8} lg={4}>

                <Card>

                    <Statistic

                        title="Négociations"

                        value={stats.negotiation}

                        valueStyle={{

                            color:"#1890ff"

                        }}

                        prefix={<ClockCircleOutlined />}

                    />

                </Card>

            </Col>

            <Col xs={12} md={8} lg={4}>

                <Card>

                    <Statistic

                        title="Offres"

                        value={stats.agreement}

                        valueStyle={{

                            color:"#fa8c16"

                        }}

                        prefix={<CheckCircleOutlined />}

                    />

                </Card>

            </Col>

            <Col xs={12} md={8} lg={4}>

                <Card>

                    <Statistic

                        title="Paiements"

                        value={stats.payment}

                        valueStyle={{

                            color:"#3f8600"

                        }}

                        prefix={<DollarCircleOutlined />}

                    />

                </Card>

            </Col>

            <Col xs={12} md={8} lg={4}>

                <Card>

                    <Statistic

                        title="Archivées"

                        value={stats.archived}

                        valueStyle={{

                            color:"#8c8c8c"

                        }}

                        prefix={<InboxOutlined />}

                    />

                </Card>

            </Col>

        </Row>

    );

};

export default NotificationStats;